import cauOverlayImg from 'src/assets/images/user-mobile/map/overlay/cauOverlay.webp';
import khuOverlayImg from 'src/assets/images/user-mobile/map/overlay/khuOverlay.webp';
import jejulhfestivalOverlayImg from 'src/assets/images/user-mobile/map/overlay/jejulhfestivalOverlay.webp';
import firefestivaljejuOverlayImg from 'src/assets/images/user-mobile/map/overlay/firefestivaljejuOverlay.webp';
import cherryblossomOverlayImg from 'src/assets/images/user-mobile/map/overlay/cherryblossomOverlay.webp';
import djdroneOverlayImg from 'src/assets/images/user-mobile/map/overlay/djdroneOverlay.webp';
import mokpowshowOverlayImg from 'src/assets/images/user-mobile/map/overlay/mokpowshowOverlay.webp';
import wheatOverlayImg from 'src/assets/images/user-mobile/map/overlay/wheatOverlay.webp';

import { IS_ONLY_MOBILE } from 'src/consts/config.const';
import getSubAddress from '../getSubAddress';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function makeOverlay(mapRef: any) {
  const cauBounds = new naver.maps.LatLngBounds(
    new naver.maps.LatLng(37.50160074857147, 126.95373077285015), // sw
    new naver.maps.LatLng(37.507146090792496, 126.95969965964029), // en
  );
  const khuBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(37.235009623555095, 127.07569218952227), // sw
    new naver.maps.LatLng(37.24911010011597, 127.09002193461744), // en
  );
  const jejulhfestivalBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(33.54266434796413, 126.66844585589458), // sw
    new naver.maps.LatLng(33.54414864765099, 126.6711407421144), // en
  );
  const firefestivaljejuBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(33.358197216008065, 126.35472398844779), // sw
    new naver.maps.LatLng(33.368904197944595, 126.3648878354728), // en
  );
  const CherryBlossomBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(33.50197879340216, 126.5132552015567), // sw
    new naver.maps.LatLng(33.50572251640002, 126.5178323983849), // en
  );
  const DjdroneBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(36.890740609167075, 126.82207826006993), // sw
    new naver.maps.LatLng(36.89458026365346, 126.82570226656307), // en
  );
  // const DjdroneControlAreaBounds = new naver.maps.LatLngBounds(
  //   // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
  //   new naver.maps.LatLng(36.890740609167075, 126.82207826006993), // sw
  //   new naver.maps.LatLng(36.89458026365346, 126.82570226656307), // en
  // );
  const MokpowshowBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(34.79512766861447, 126.4317966009311), // sw
    new naver.maps.LatLng(34.79686676759493, 126.43457110512742), // en
  );
  const WheatBounds = new naver.maps.LatLngBounds(
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    new naver.maps.LatLng(35.213462623290724, 128.9984006486478), // sw
    new naver.maps.LatLng(35.218088753422926, 129.0022031030634), // en
  );

  const subAddress = getSubAddress(IS_ONLY_MOBILE);

  const firefestivaljejuOverlay = new naver.maps.GroundOverlay(
    firefestivaljejuOverlayImg,
    firefestivaljejuBounds,
    { opacity: 1, clickable: false },
  );

  const cauOverlay = new naver.maps.GroundOverlay(cauOverlayImg, cauBounds, {
    opacity: 1,
    clickable: false,
  });

  const khuOverlay = new naver.maps.GroundOverlay(khuOverlayImg, khuBounds, {
    opacity: 1,
    clickable: false,
  });
  const jejulhfestivalOverlay = new naver.maps.GroundOverlay(
    jejulhfestivalOverlayImg,
    jejulhfestivalBounds,
    { opacity: 1, clickable: false },
  );

  const CherryBlossomOverlay = new naver.maps.GroundOverlay(
    cherryblossomOverlayImg,
    CherryBlossomBounds,
    { opacity: 1, clickable: false },
  );
  const DjdroneOverlay = new naver.maps.GroundOverlay(
    djdroneOverlayImg,
    DjdroneBounds,
    { opacity: 1, clickable: false },
  );
  const MokpowshowOverlay = new naver.maps.GroundOverlay(
    mokpowshowOverlayImg,
    MokpowshowBounds,
    { opacity: 1, clickable: false },
  );
  const WheatOverlay = new naver.maps.GroundOverlay(
    wheatOverlayImg,
    WheatBounds,
    { opacity: 1, clickable: false },
  );
  // const DjdroneControlAreaOverlay = new naver.maps.GroundOverlay(
  //   djdronecontrolareaOverlayImg,
  //   DjdroneControlAreaBounds,
  //   { opacity: 1, clickable: false },
  // );
  if (subAddress === 'cau') cauOverlay.setMap(mapRef.current);
  else if (subAddress === 'adelante') khuOverlay.setMap(mapRef.current);
  else if (subAddress === 'jejulhfestival')
    jejulhfestivalOverlay.setMap(mapRef.current);
  else if (subAddress === 'firefestivaljeju')
    firefestivaljejuOverlay.setMap(mapRef.current);
  else if (subAddress === 'cherryblossom')
    CherryBlossomOverlay.setMap(mapRef.current);
  else if (subAddress === 'djdrone') {
    DjdroneOverlay.setMap(mapRef.current);
    // DjdroneControlAreaOverlay.setMap(mapRef.current);
  } else if (subAddress === 'mokpowshow')
    MokpowshowOverlay.setMap(mapRef.current);
  else if (subAddress === 'wheat') WheatOverlay.setMap(mapRef.current);
}

export default makeOverlay;

// mokpowshow.
